module.exports = __webpack_public_path__ + "images/program/calendar.bfec2e2d.svg";